import request from '@/utils/request';

export default {
    getDriverBonuses: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/admin/bonuses/drivers', params })
            .then(res => {
                if (res.data) {
                    commit('PROCCESS_RES', Object.assign({}, res.data, {
                        stateType: 'driver'
                    }));
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getClientBonuses: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/admin/bonuses/clients/bonusUseLimits', params })
            .then(res => {
                if (res.data) {
                    commit('PROCCESS_RES', Object.assign({}, res.data, {
                        stateType: 'client'
                    }));
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    }
};
